import{toNumber as i}from"./toNumber.js";function o(n){return n?(n=i(n),n===1/0||n===-1/0?(n<0?-1:1)*Number.MAX_VALUE:n===n?n:0):n===0?n:0}export{o as toFinite};
